const INITIAL_COURSE_ID = 4

const FULLY_COURSE_ID = 14

export default {
  INITIAL_COURSE_ID,
  FULLY_COURSE_ID,
}
